import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import StatLineGauge from 'app/components/Gauges/StatLineGauge';
import TeamName from 'app/components/TeamName';
import PicksAndBans from 'app/components/Blocks/TeamsStatsBlock/PicksAndBans';

import { getLolTeamStatsLines } from './utils';
import LolRadarChart from './LolRadarChart';
import style from './style.module.scss';

interface Props {
  data: TeamsStatsBlockMatch;
}

const LolTeamStats: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  const lines = getLolTeamStatsLines(data);

  return (
    <>
      <h3 className={style.teamPlaystyleTitle}>
        {t('blocks_teams-stats_videogame_lol_team-playstyle')}
      </h3>

      <div className={style.teamStatsContainer}>
        <LolRadarChart data={data} className={style.chartContainer} chartClassName={style.chart} />

        <div className={style.gaugesContainer}>
          <TeamName.Container className={style.teamsNames}>
            <TeamName
              team={data.opponents.at(0)}
              logoStyle={style.teamNameLogoSize}
              teamNamesClassName={style.teamNameClassName}
            />
            <TeamName
              team={data.opponents.at(1)}
              logoStyle={style.teamNameLogoSize}
              teamNamesClassName={style.teamNameClassName}
              orientation="reversed"
            />
          </TeamName.Container>
          <StatLineGauge
            className={style.statsLineGauges}
            lines={lines}
            translationKey="blocks_teams-stats_videogame_lol"
          />
        </div>

        <PicksAndBans
          className={style.picksContainer}
          opponent1PicksAndbans={data.opponents.at(0)?.stats as StatsLol | undefined}
          opponent2PicksAndbans={data.opponents.at(1)?.stats as StatsLol | undefined}
          videogame="lol"
        />
      </div>
    </>
  );
};

LolTeamStats.displayName = 'LolTeamStats';

export default LolTeamStats;
